import { Alert } from '@mui/material'

import { form } from '../../../formState'
import { useCreateIsSegmentOutsideOfTerritory } from '../../../hooks/useCreateIsSegmentOutsideOfTerritory'
import { useTexts } from '../../../hooks/useTexts'
import { InfoBanner } from './InfoBanner'

export function DrawRoadSegment() {
  const { field, errors } = form.useFormField('editableSegment')
  const type = form.useFormField('type')
  const texts = useTexts()
  const isSegmentOutsideOfTerritory = useCreateIsSegmentOutsideOfTerritory()

  form.useAddFieldValidation<'editableSegment'>('editableSegment', (field, _formApi) => {
    if (!field.value) {
      return texts.errorEditableSegment
    }

    if (field.value && isSegmentOutsideOfTerritory(field.value)) {
      return texts.cardDescription
    }
  })

  return (
    <form.Fieldset>
      <form.DrawRoadSegmentField
        name="editableSegment"
        drawRoadSegmentProps={{
          id: 'roadSegment',
          type: type.field.value,
          initialCoords: field.value,
        }}
      />

      <InfoBanner />

      {errors.length > 0 && (
        <Alert severity="error" component="div">
          {errors[0].message}
        </Alert>
      )}
    </form.Fieldset>
  )
}
